<nav
    v-if="isPaginated"
    class="pagination mt-1.5 mb-1 print:hidden"
    role="navigation"
    aria-label="Pagination Navigation"
>
    <ul class="flex items-center justify-center">
        <!-- Prev Button -->
        <li
            class="ml-qtr mr-qtr"
        >
            <button
                aria-label="Previous page"
                v-on:click="prevPage();"
                :disabled="currentPage === 1"
                class="button hollow !border-transparent disabled:opacity-50 disabled:cursor-not-allowed disabled:text-gray-500"
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-1.5 h-1.5 stroke-2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
                <span class="sr-only">Prev</span>
            </button>
        </li>

        <!-- Page numbers -->
        <li v-for="page in displayedPages" :key="page" class="ml-qtr mr-qtr" :class="{ 'hidden sm:list-item': page !== currentPage }">
            <span v-if="page === '...'" class="text-primary">...</span>
            <button
                v-else
                v-bind:aria-label="'page ' + page"
                v-on:click="gotoPage(page);"
                :class="{'button': true, 'hollow': currentPage !== page, 'active': currentPage === page}"
                :disabled="currentPage === page"
            >
                <span>{{ page }}</span>
            </button>
        </li>

        <!-- Next Button -->
        <li
            class="ml-qtr mr-qtr"
        >
            <button
                aria-label="Next page"
                v-on:click="nextPage();"
                :disabled="currentPage === totalPages"
                class="button hollow !border-transparent disabled:opacity-50 disabled:cursor-not-allowed disabled:text-gray-500"
            >
                <span class="sr-only">Next</span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-1.5 h-1.5 stroke-2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
            </button>
        </li>
    </ul>
</nav>
